import { BOOK_ALIAS_THIS_IS_MY_DREAM_LINE } from '@shared/jp/product';
import type { IBookPreview } from '@shared/jp/data/products';

/**
 * gift-use/gift-buy screens show this-is-my-dream-line under a different
 * name than its marketing `caption`
 */
export const getGiftCaption = (
  book: IBookPreview,
  fallback: string = book.caption,
): string =>
  book.alias === BOOK_ALIAS_THIS_IS_MY_DREAM_LINE
    ? book.notice.caption
    : fallback;
